import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { InlineEdit, TEXT_LENGTH } from '@nile/components';
import { DisplayText, TextField, TextStyle } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';

const Subject = styled.div`
  .subject {
    font-size: 20px !important;
    font-weight: bold;
    height: fit-content;
    white-space: pre-wrap;
    line-break: anywhere;

    .edit-icon {
      visibility: hidden;
      margin-left: 5px;
      display: inline;
    }
  }
  .subject-name {
    height: 100%;
    line-height: 3.3rem;
    max-height: 110px;
    overflow: auto;
    padding-right: 5px;
    // white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // max-width: 350px;
  }
  .subject:hover {
    .edit-icon {
      visibility: visible;
      display: inline;
    }
  }
`;

const InlineTextField = (props) => {
  const {
    fontSize = 'fontMedium',
    size = 'default',
    readViewSize = ' default',
    placeholder = '',
    readViewWeight = 'Medium',
    multiline = true,
    ellipsis = true
  } = props;
  const [value, setValue] = useState(props.defaultValue);

  useEffect(() => {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  const getReadView = () => {
    return (
      <div className="subject flex actr">
        <div className={ellipsis && 'ellipsis'}>
          <DisplayText
            element="span"
            size={readViewSize}
            weight={readViewWeight}
          >
            {value || placeholder}
          </DisplayText>
        </div>

        <div className="edit-icon flex">
          <SVGIcon name="Edit" />
        </div>
      </div>
    );
  };

  return (
    <Subject>
      <InlineEdit
        defaultValue={value}
        editView={({ updateFieldState }, ref) => (
          <div className="mr8">
            <TextField
              value={value}
              onChange={(text) => {
                setValue(text);
                updateFieldState(text);
              }}
              onFocus={(event) => event.target.select()}
              autoFocus={props.editMode}
              ref={ref}
              maxLength={TEXT_LENGTH.size_5}
              maxHeight="110px"
              fontSize={fontSize}
              size={size}
              noborder
              bgTransparent
              multiline={multiline}
              placeholder={placeholder}
              focused
            />
          </div>
        )}
        saveOnEnter={props.saveOnEnter}
        editMode={props.editMode}
        onCancel={props.onCancel}
        readView={getReadView}
        onConfirm={(text, cb) => {
          if (!value?.trim()) setValue(props.defaultValue);
          else setValue(value.trim());
          if (props.saveValue) props.saveValue(value, cb);
        }}
        onEditStateChange={(state) => {
          if (props.setEditState) props.setEditState(state);
        }}
        showProgress
        editable
        hideActionButtons
      />
    </Subject>
  );
};

InlineTextField.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  saveValue: PropTypes.func,
  setEditState: PropTypes.func
};

export default InlineTextField;
